// Time signature presets. Each defines the default beat count and accent pattern.
// Pattern values: 0 = off, 1 = normal, 2 = accent.

export const TIME_SIGNATURES = [
  { id: '1/4', label: '1/4', beats: 1, pattern: [2] },
  { id: '2/4', label: '2/4', beats: 2, pattern: [2, 1] },
  { id: '3/4', label: '3/4', beats: 3, pattern: [2, 1, 1] },
  { id: '4/4', label: '4/4', beats: 4, pattern: [2, 1, 1, 1] },
  { id: '5/4', label: '5/4', beats: 5, pattern: [2, 1, 1, 1, 1] },
  { id: '6/4', label: '6/4', beats: 6, pattern: [2, 1, 1, 1, 1, 1] },
  { id: '7/4', label: '7/4', beats: 7, pattern: [2, 1, 1, 1, 1, 1, 1] },
  { id: '6/8', label: '6/8', beats: 6, pattern: [2, 1, 1, 1, 1, 1] },
  { id: '7/8', label: '7/8', beats: 7, pattern: [2, 1, 1, 2, 1, 1, 1] },
  { id: '9/8', label: '9/8', beats: 9, pattern: [2, 1, 1, 2, 1, 1, 2, 1, 1] },
  { id: '12/8', label: '12/8', beats: 12, pattern: [2, 1, 1, 2, 1, 1, 2, 1, 1, 2, 1, 1] },
  { id: 'custom', label: 'Custom', beats: 8, pattern: [2, 1, 1, 1, 2, 1, 1, 1] },
];

export const findSig = (id) => TIME_SIGNATURES.find((s) => s.id === id) || TIME_SIGNATURES[3];
